import { createDynamicSlice } from ".";
import { fetchAuditsThunk } from "../thunks/auditsThunk";

export const auditsSlice = createDynamicSlice({
  name: "audits",
  thunk: fetchAuditsThunk,
  listMode: true,
  resetActionName: "resetAudits",
});

export const auditsReducer = auditsSlice.reducer;
export const { resetAudits } = auditsSlice.actions;
